/**
 * HT — Parte 1 (filas 5–18): logo, cabecera empresa, títulos, Nr., texto legal.
 */

export const HT_PART1_ROW_START = 5;
export const HT_PART1_ROW_END = 18;

export const HT_PART1_ROW_HEIGHTS = {
  5: 13.8,
  6: 15,
  7: 20.55,
  8: 20.55,
  9: 12.45,
  10: 15,
  11: 15,
  12: 12.45,
  15: 24,
  16: 12.45,
  17: 84,
  18: 63,
};

function setCell(ws, r, c, value, fontBase, opts = {}) {
  const cell = ws.getCell(r, c);
  cell.value = value == null || value === '' ? null : value;
  cell.font = { ...fontBase, ...(opts.bold ? { bold: true } : {}) };
  cell.alignment = {
    vertical: opts.align?.vertical ?? 'top',
    horizontal: opts.align?.horizontal ?? 'left',
    wrapText: opts.wrap !== false,
  };
}

export function writeHtPart1Excel(ws, params, fontBase) {
  const S = params.static;

  const empresaRows = [
    [7, S.HT_EMPRESA_HEADER.d7, S.HT_EMPRESA_HEADER.e7],
    [8, S.HT_EMPRESA_HEADER.d8, S.HT_EMPRESA_HEADER.e8],
    [9, S.HT_EMPRESA_HEADER.d9, S.HT_EMPRESA_HEADER.e9],
    [10, S.HT_EMPRESA_HEADER.d10, S.HT_EMPRESA_HEADER.e10],
    [11, S.HT_EMPRESA_HEADER.d11, S.HT_EMPRESA_HEADER.e11],
  ];
  empresaRows.forEach(([row, d, e]) => {
    setCell(ws, row, 4, d, fontBase, { align: { vertical: 'middle' }, wrap: false });
    setCell(ws, row, 5, e, fontBase, { align: { vertical: 'middle' }, wrap: false });
  });

  setCell(ws, 13, 3, S.HT_TITULO_PT.trim(), fontBase, {
    bold: true,
    align: { vertical: 'middle', horizontal: 'center' },
    wrap: true,
  });
  setCell(ws, 15, 3, S.HT_TITULO_EN.trim(), fontBase, {
    bold: true,
    align: { vertical: 'middle', horizontal: 'center' },
    wrap: true,
  });
  setCell(ws, 13, 5, params.certificadoNrLine, fontBase, {
    bold: true,
    align: { vertical: 'middle', horizontal: 'center' },
  });

  setCell(ws, 17, 3, S.HT_INTRO, fontBase, {
    align: { vertical: 'middle', horizontal: 'left' },
    wrap: true,
  });
}
